/* eslint-disable @typescript-eslint/no-empty-function */

/** Force class to implement interface members as static members. */
export const StaticImplements =
  <T extends new (...args: Array<unknown>) => void>(): ((c: T) => void) =>
  (ctor: T): void => {
    ctor;
  };
